<template>
  <div>
    <div class="flex flex-col-reverse gap-y-1 lg:mt-10 lg:flex-row lg:gap-x-2 lg:gap-y-0">
      <BaseButtonGroup class="hidden w-full lg:flex" size="L">
        <BaseTextButton
          v-for="scaleUnit in scale.items"
          :key="scaleUnit.value"
          size="L"
          color="filled"
          shape="round"
          class="text-title-small! shrink! basis-full px-4! whitespace-normal!"
          :class="[suggestedValue == scaleUnit.value && 'ring-primary ring-2 ring-offset-3']"
          :toggle="true"
          :selected="feedbackValue == scaleUnit.value"
          @click.stop.prevent="updateValue(scaleUnit.value)"
        >
          <img
            :src="scaleUnit.image"
            class="h-8 w-full md:h-24"
            :class="[feedbackValue == scaleUnit.value && 'invert-100']"
          />
        </BaseTextButton>
      </BaseButtonGroup>
      <BaseButtonGroup class="lg:hidden" size="M" direction="vertical">
        <BaseTextButton
          v-for="scaleUnit in scale.items"
          :key="scaleUnit.value"
          size="M"
          color="filled"
          shape="round"
          :class="[suggestedValue == scaleUnit.value && 'ring-primary ring-2 ring-offset-2']"
          :toggle="true"
          :selected="feedbackValue == scaleUnit.value"
          @click.stop.prevent="updateValue(scaleUnit.value)"
          ><img
            :src="scaleUnit.image"
            class="h-24 w-full"
            :class="[feedbackValue == scaleUnit.value && 'invert-100']"
        /></BaseTextButton>
      </BaseButtonGroup>
    </div>
  </div>
</template>
<script setup lang="ts">
  import BaseButtonGroup from '../../../../core/components/base/button/BaseButtonGroup.vue'
  import BaseTextButton from '../../../../core/components/base/button/text-button/BaseTextButton.vue'
  import type { ImageButtonScale } from '../../../../core/models/scale'

  interface Props {
    scale: ImageButtonScale
    identifier: string
    disabled?: boolean
    suggestedValue?: number
  }

  defineProps<Props>()

  const feedbackValue = defineModel<number>()

  const updateValue = (value: number | undefined) => {
    if (feedbackValue.value == value) {
      feedbackValue.value = undefined
    } else {
      feedbackValue.value = value
    }
  }
</script>
